import React from 'react';
import "./Form.css";

const Button = (props) => {
    return (<button className="submitBtn mt-4"  onClick={props.func}>{props.caption}</button>)
}

export default Button;